var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadAppGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 135 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-8{fill:#fff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{opacity:0.2;}.cls-6,.cls-7,.cls-8{isolation:isolate;}.cls-7{opacity:0.12;}.cls-8{opacity:0.25;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 21.8,
    y1: 23.29,
    x2: 5.02,
    y2: 6.51,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 33.83,
    y1: 12,
    x2: 9.64,
    y2: 12,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 24.83,
    y1: 9.7,
    x2: 2.07,
    y2: -13.05,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 7.3,
    y1: 31.82,
    x2: 17.46,
    y2: 21.66,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Google_Play_EN_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 40,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.46,9.69H44.37v.92h2.17a1.77,1.77,0,0,1-.47,1.05,2.19,2.19,0,0,1-1.6.64A2.22,2.22,0,0,1,42.24,10a2.22,2.22,0,0,1,2.23-2.3A1.93,1.93,0,0,1,46,8.38l.07.08.66-.67-.05-.07a2.63,2.63,0,0,0-1-.69,3.07,3.07,0,0,0-1.27-.26A3.19,3.19,0,0,0,41.25,10a3.19,3.19,0,0,0,3.22,3.23,3,3,0,0,0,2.27-.91,2.82,2.82,0,0,0,.78-2.08,3.89,3.89,0,0,0,0-.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.42 13.1 52.13 13.1 52.13 12.16 49.4 12.16 49.4 10.46 51.86 10.46 51.86 9.54 49.4 9.54 49.4 7.84 52.13 7.84 52.13 6.9 48.42 6.9 48.42 13.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.73 7.84 54.41 7.84 54.41 13.1 55.38 13.1 55.38 7.84 57.05 7.84 57.05 6.9 52.73 6.9 52.73 7.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.84,
    y: 6.9,
    width: 0.97,
    height: 6.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61.58 7.84 63.26 7.84 63.26 13.1 64.23 13.1 64.23 7.84 65.9 7.84 65.9 6.9 61.58 6.9 61.58 7.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.41,6.77a3,3,0,0,0-2.27.94A3.15,3.15,0,0,0,68.23,10a3.15,3.15,0,0,0,.91,2.29,3.21,3.21,0,0,0,4.54,0A3.15,3.15,0,0,0,74.59,10a3.16,3.16,0,0,0-.91-2.29A3,3,0,0,0,71.41,6.77ZM73.61,10A2.27,2.27,0,0,1,73,11.65a2.2,2.2,0,0,1-3.12,0A2.27,2.27,0,0,1,69.21,10a2.27,2.27,0,0,1,.64-1.65,2.2,2.2,0,0,1,3.12,0A2.27,2.27,0,0,1,73.61,10Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "79.33 6.9 79.33 10.51 79.35 11.36 76.57 6.9 75.47 6.9 75.47 13.1 76.45 13.1 76.45 9.26 76.42 8.42 79.31 13.05 79.34 13.1 80.3 13.1 80.3 6.9 79.33 6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.14,21.75A4.26,4.26,0,1,0,72.41,26,4.19,4.19,0,0,0,68.14,21.75Zm0,6.83A2.58,2.58,0,1,1,70.54,26,2.46,2.46,0,0,1,68.14,28.58Zm-9.32-6.83A4.26,4.26,0,1,0,63.09,26,4.19,4.19,0,0,0,58.82,21.75Zm0,6.83A2.58,2.58,0,1,1,61.22,26,2.46,2.46,0,0,1,58.82,28.58ZM47.74,23.06v1.8h4.32a3.77,3.77,0,0,1-1,2.27,4.42,4.42,0,0,1-3.34,1.32,4.8,4.8,0,0,1,0-9.6A4.64,4.64,0,0,1,51,20.14l1.27-1.27a6.3,6.3,0,0,0-4.53-1.82,6.61,6.61,0,1,0,0,13.21,6.07,6.07,0,0,0,4.61-1.85,6,6,0,0,0,1.56-4.23,6.27,6.27,0,0,0-.09-1.12Zm45.31,1.4a4,4,0,0,0-3.64-2.71,4,4,0,0,0-4,4.25,4.23,4.23,0,0,0,7.76,2.37l-1.45-1a2.41,2.41,0,0,1-2.09,1.17,2.15,2.15,0,0,1-2.06-1.29l5.69-2.35Zm-5.8,1.42a2.34,2.34,0,0,1,2.23-2.49,1.64,1.64,0,0,1,1.57.91ZM82.63,30H84.5V17.5H82.63Zm-3.06-7.3H79.5a2.94,2.94,0,0,0-2.24-.95,4.26,4.26,0,0,0,0,8.51,2.88,2.88,0,0,0,2.24-1h.07v.61c0,1.63-.87,2.5-2.27,2.5a2.36,2.36,0,0,1-2.15-1.51l-1.62.67a4,4,0,0,0,3.77,2.52c2.19,0,4-1.29,4-4.43V22H79.57Zm-2.15,5.88a2.58,2.58,0,0,1,0-5.15A2.39,2.39,0,0,1,79.7,26,2.38,2.38,0,0,1,77.42,28.58ZM101.81,17.5H97.33V30H99.2V25.26h2.61a3.89,3.89,0,1,0,0-7.76Zm0,6H99.2V19.24h2.65a2.14,2.14,0,1,1,0,4.28Zm11.54-1.79a3.49,3.49,0,0,0-3.33,1.91l1.65.69a1.78,1.78,0,0,1,1.71-.91,1.8,1.8,0,0,1,2,1.61v.12a4.18,4.18,0,0,0-1.95-.48c-1.78,0-3.6,1-3.6,2.82a2.89,2.89,0,0,0,3.11,2.75A2.65,2.65,0,0,0,115.32,29h.06v1h1.8V25.19C117.18,23,115.52,21.73,113.39,21.73Zm-.23,6.85c-.61,0-1.46-.31-1.46-1.06,0-1,1.06-1.34,2-1.34a3.32,3.32,0,0,1,1.7.42A2.26,2.26,0,0,1,113.16,28.58ZM123.74,22l-2.14,5.42h-.06L119.32,22h-2l3.33,7.58-1.9,4.21h2L125.82,22Zm-16.8,8h1.86V17.5h-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.44,7.54A2,2,0,0,0,10,8.94V31.06a1.94,1.94,0,0,0,.47,1.4l.07.08L22.9,20.15v-.3L10.51,7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27,24.28,22.9,20.15v-.3L27,15.72l.09.06L32,18.56c1.4.79,1.4,2.09,0,2.89l-4.89,2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.12,24.23,22.9,20,10.44,32.46a1.62,1.62,0,0,0,2.07.07l14.61-8.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M27.12,15.78,12.51,7.48a1.61,1.61,0,0,0-2.07.06L22.9,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M27,24.13,12.51,32.38a1.66,1.66,0,0,1-2,0h0l-.07.07h0l.07.08h0a1.66,1.66,0,0,0,2,0l14.61-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M10.44,32.32A2,2,0,0,1,10,30.91v.15a1.94,1.94,0,0,0,.47,1.4l.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M32,21.3l-5,2.83.09.1L32,21.44A1.75,1.75,0,0,0,33.06,20h0A1.86,1.86,0,0,1,32,21.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M12.51,7.62,32,18.7A1.86,1.86,0,0,1,33.06,20h0A1.75,1.75,0,0,0,32,18.56L12.51,7.48C11.12,6.68,10,7.34,10,8.94v.15C10,7.49,11.12,6.83,12.51,7.62Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAppGoogle);
export default __webpack_public_path__ + "static/media/download-app-google.99b0714ba72f06be37b6d686ea0c949e.svg";
export { ForwardRef as ReactComponent };